export const HydraBoostDailyTrialFixture = {
  id: 2,
  title: 'Lens Trial',
  handle: 'trial-daily-lenses',
  description:
    'Designed for optimum comfort and moisture. Each lens is made from ultra-breathable Etafilcon A with a high water content of 58%.',
  productVariants: [
    {
      id: 51,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-0-50',
      label: null,
      description: null,
      assets: [
        {
          asset: {
            id: 1,
            path: '/images/products/original-lens/subscription-lens-blister.png',
          },
        },
      ],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.50',
            value: '-0.50',
            id: 1,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 201,
          region: 'US',
          sku: 'WALFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 202,
          region: 'UK',
          sku: 'WALFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 203,
          region: 'SE',
          sku: 'WALFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 204,
          region: 'EU',
          sku: 'WALFIRST-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 52,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.75',
            value: '-0.75',
            id: 2,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 205,
          region: 'US',
          sku: 'WALFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 206,
          region: 'UK',
          sku: 'WALFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 207,
          region: 'SE',
          sku: 'WALFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 208,
          region: 'EU',
          sku: 'WALFIRST-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 53,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.00',
            value: '-1.00',
            id: 3,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 209,
          region: 'US',
          sku: 'WALFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 210,
          region: 'UK',
          sku: 'WALFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 211,
          region: 'SE',
          sku: 'WALFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 212,
          region: 'EU',
          sku: 'WALFIRST-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 54,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.25',
            value: '-1.25',
            id: 4,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 213,
          region: 'US',
          sku: 'WALFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 214,
          region: 'UK',
          sku: 'WALFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 215,
          region: 'SE',
          sku: 'WALFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 216,
          region: 'EU',
          sku: 'WALFIRST-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 55,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.50',
            value: '-1.50',
            id: 5,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 217,
          region: 'US',
          sku: 'WALFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 218,
          region: 'UK',
          sku: 'WALFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 219,
          region: 'SE',
          sku: 'WALFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 220,
          region: 'EU',
          sku: 'WALFIRST-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 56,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.75',
            value: '-1.75',
            id: 6,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 221,
          region: 'US',
          sku: 'WALFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 222,
          region: 'UK',
          sku: 'WALFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 223,
          region: 'SE',
          sku: 'WALFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 224,
          region: 'EU',
          sku: 'WALFIRST-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 57,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.00',
            value: '-2.00',
            id: 7,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 225,
          region: 'US',
          sku: 'WALFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 226,
          region: 'UK',
          sku: 'WALFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 227,
          region: 'SE',
          sku: 'WALFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 228,
          region: 'EU',
          sku: 'WALFIRST-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 58,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.25',
            value: '-2.25',
            id: 8,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 229,
          region: 'US',
          sku: 'WALFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 230,
          region: 'UK',
          sku: 'WALFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 231,
          region: 'SE',
          sku: 'WALFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 232,
          region: 'EU',
          sku: 'WALFIRST-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 59,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.50',
            value: '-2.50',
            id: 9,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 233,
          region: 'US',
          sku: 'WALFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 234,
          region: 'UK',
          sku: 'WALFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 235,
          region: 'SE',
          sku: 'WALFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 236,
          region: 'EU',
          sku: 'WALFIRST-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 60,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.75',
            value: '-2.75',
            id: 10,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 237,
          region: 'US',
          sku: 'WALFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 238,
          region: 'UK',
          sku: 'WALFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 239,
          region: 'SE',
          sku: 'WALFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 240,
          region: 'EU',
          sku: 'WALFIRST-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 61,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.00',
            value: '-3.00',
            id: 11,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 241,
          region: 'US',
          sku: 'WALFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 242,
          region: 'UK',
          sku: 'WALFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 243,
          region: 'SE',
          sku: 'WALFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 244,
          region: 'EU',
          sku: 'WALFIRST-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 62,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.25',
            value: '-3.25',
            id: 12,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 245,
          region: 'US',
          sku: 'WALFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 246,
          region: 'UK',
          sku: 'WALFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 247,
          region: 'SE',
          sku: 'WALFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 248,
          region: 'EU',
          sku: 'WALFIRST-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 63,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.50',
            value: '-3.50',
            id: 13,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 249,
          region: 'US',
          sku: 'WALFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 250,
          region: 'UK',
          sku: 'WALFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 251,
          region: 'SE',
          sku: 'WALFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 252,
          region: 'EU',
          sku: 'WALFIRST-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 64,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.75',
            value: '-3.75',
            id: 14,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 253,
          region: 'US',
          sku: 'WALFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 254,
          region: 'UK',
          sku: 'WALFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 255,
          region: 'SE',
          sku: 'WALFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 256,
          region: 'EU',
          sku: 'WALFIRST-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 65,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.00',
            value: '-4.00',
            id: 15,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 257,
          region: 'US',
          sku: 'WALFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 258,
          region: 'UK',
          sku: 'WALFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 259,
          region: 'SE',
          sku: 'WALFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 260,
          region: 'EU',
          sku: 'WALFIRST-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 66,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-4-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.25',
            value: '-4.25',
            id: 16,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 261,
          region: 'US',
          sku: 'WALFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 262,
          region: 'UK',
          sku: 'WALFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 263,
          region: 'SE',
          sku: 'WALFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 264,
          region: 'EU',
          sku: 'WALFIRST-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 67,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-4-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.50',
            value: '-4.50',
            id: 17,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 265,
          region: 'US',
          sku: 'WALFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 266,
          region: 'UK',
          sku: 'WALFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 267,
          region: 'SE',
          sku: 'WALFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 268,
          region: 'EU',
          sku: 'WALFIRST-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 68,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-4-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.75',
            value: '-4.75',
            id: 18,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 269,
          region: 'US',
          sku: 'WALFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 270,
          region: 'UK',
          sku: 'WALFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 271,
          region: 'SE',
          sku: 'WALFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 272,
          region: 'EU',
          sku: 'WALFIRST-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 69,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-5-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.00',
            value: '-5.00',
            id: 19,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 273,
          region: 'US',
          sku: 'WALFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 274,
          region: 'UK',
          sku: 'WALFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 275,
          region: 'SE',
          sku: 'WALFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 276,
          region: 'EU',
          sku: 'WALFIRST-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 70,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-5-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.25',
            value: '-5.25',
            id: 20,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 277,
          region: 'US',
          sku: 'WALFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 278,
          region: 'UK',
          sku: 'WALFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 279,
          region: 'SE',
          sku: 'WALFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 280,
          region: 'EU',
          sku: 'WALFIRST-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 71,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-5-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.50',
            value: '-5.50',
            id: 21,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 281,
          region: 'US',
          sku: 'WALFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 282,
          region: 'UK',
          sku: 'WALFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 283,
          region: 'SE',
          sku: 'WALFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 284,
          region: 'EU',
          sku: 'WALFIRST-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 72,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-5-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.75',
            value: '-5.75',
            id: 22,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 285,
          region: 'US',
          sku: 'WALFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 286,
          region: 'UK',
          sku: 'WALFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 287,
          region: 'SE',
          sku: 'WALFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 288,
          region: 'EU',
          sku: 'WALFIRST-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 73,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-6-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.00',
            value: '-6.00',
            id: 23,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 289,
          region: 'US',
          sku: 'WALFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 290,
          region: 'UK',
          sku: 'WALFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 291,
          region: 'SE',
          sku: 'WALFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 292,
          region: 'EU',
          sku: 'WALFIRST-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 74,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-6-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.50',
            value: '-6.50',
            id: 24,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 293,
          region: 'US',
          sku: 'WALFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 294,
          region: 'UK',
          sku: 'WALFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 295,
          region: 'SE',
          sku: 'WALFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 296,
          region: 'EU',
          sku: 'WALFIRST-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 75,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-7-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.00',
            value: '-7.00',
            id: 25,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 297,
          region: 'US',
          sku: 'WALFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 298,
          region: 'UK',
          sku: 'WALFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 299,
          region: 'SE',
          sku: 'WALFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 300,
          region: 'EU',
          sku: 'WALFIRST-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 76,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-7-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.50',
            value: '-7.50',
            id: 26,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 301,
          region: 'US',
          sku: 'WALFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 302,
          region: 'UK',
          sku: 'WALFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 303,
          region: 'SE',
          sku: 'WALFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 304,
          region: 'EU',
          sku: 'WALFIRST-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 77,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-8-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.00',
            value: '-8.00',
            id: 27,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 305,
          region: 'US',
          sku: 'WALFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 306,
          region: 'UK',
          sku: 'WALFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 307,
          region: 'SE',
          sku: 'WALFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 308,
          region: 'EU',
          sku: 'WALFIRST-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 78,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-8-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.50',
            value: '-8.50',
            id: 28,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 309,
          region: 'US',
          sku: 'WALFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 310,
          region: 'UK',
          sku: 'WALFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 311,
          region: 'SE',
          sku: 'WALFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 312,
          region: 'EU',
          sku: 'WALFIRST-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 79,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-9-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.00',
            value: '-9.00',
            id: 29,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 313,
          region: 'US',
          sku: 'WALFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 314,
          region: 'UK',
          sku: 'WALFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 315,
          region: 'SE',
          sku: 'WALFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 316,
          region: 'EU',
          sku: 'WALFIRST-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 80,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-9-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.50',
            value: '-9.50',
            id: 30,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 317,
          region: 'US',
          sku: 'WALFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 318,
          region: 'UK',
          sku: 'WALFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 319,
          region: 'SE',
          sku: 'WALFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 320,
          region: 'EU',
          sku: 'WALFIRST-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 81,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-10-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.00',
            value: '-10.00',
            id: 31,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 321,
          region: 'US',
          sku: 'WALFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 322,
          region: 'UK',
          sku: 'WALFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 323,
          region: 'SE',
          sku: 'WALFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 324,
          region: 'EU',
          sku: 'WALFIRST-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 82,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-10-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.50',
            value: '-10.50',
            id: 32,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 325,
          region: 'US',
          sku: 'WALFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 326,
          region: 'UK',
          sku: 'WALFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 327,
          region: 'SE',
          sku: 'WALFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 328,
          region: 'EU',
          sku: 'WALFIRST-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 83,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-11-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.00',
            value: '-11.00',
            id: 33,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 329,
          region: 'US',
          sku: 'WALFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 330,
          region: 'UK',
          sku: 'WALFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 331,
          region: 'SE',
          sku: 'WALFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 332,
          region: 'EU',
          sku: 'WALFIRST-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 84,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-11-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.50',
            value: '-11.50',
            id: 34,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 333,
          region: 'US',
          sku: 'WALFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 334,
          region: 'UK',
          sku: 'WALFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 335,
          region: 'SE',
          sku: 'WALFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 336,
          region: 'EU',
          sku: 'WALFIRST-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 85,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-negative-12-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -12.00',
            value: '-12.00',
            id: 35,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 337,
          region: 'US',
          sku: 'WALFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 338,
          region: 'UK',
          sku: 'WALFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 339,
          region: 'SE',
          sku: 'WALFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 340,
          region: 'EU',
          sku: 'WALFIRST-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 86,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-0-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.50',
            value: '+0.50',
            id: 36,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 341,
          region: 'US',
          sku: 'WALFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 342,
          region: 'UK',
          sku: 'WALFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 343,
          region: 'SE',
          sku: 'WALFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 344,
          region: 'EU',
          sku: 'WALFIRST+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 87,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.75',
            value: '+0.75',
            id: 37,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 345,
          region: 'US',
          sku: 'WALFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 346,
          region: 'UK',
          sku: 'WALFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 347,
          region: 'SE',
          sku: 'WALFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 348,
          region: 'EU',
          sku: 'WALFIRST+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 88,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.00',
            value: '+1.00',
            id: 38,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 349,
          region: 'US',
          sku: 'WALFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 350,
          region: 'UK',
          sku: 'WALFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 351,
          region: 'SE',
          sku: 'WALFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 352,
          region: 'EU',
          sku: 'WALFIRST+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 89,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.25',
            value: '+1.25',
            id: 39,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 353,
          region: 'US',
          sku: 'WALFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 354,
          region: 'UK',
          sku: 'WALFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 355,
          region: 'SE',
          sku: 'WALFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 356,
          region: 'EU',
          sku: 'WALFIRST+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 90,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.50',
            value: '+1.50',
            id: 40,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 357,
          region: 'US',
          sku: 'WALFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 358,
          region: 'UK',
          sku: 'WALFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 359,
          region: 'SE',
          sku: 'WALFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 360,
          region: 'EU',
          sku: 'WALFIRST+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 91,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.75',
            value: '+1.75',
            id: 41,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 361,
          region: 'US',
          sku: 'WALFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 362,
          region: 'UK',
          sku: 'WALFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 363,
          region: 'SE',
          sku: 'WALFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 364,
          region: 'EU',
          sku: 'WALFIRST+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 92,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.00',
            value: '+2.00',
            id: 42,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 365,
          region: 'US',
          sku: 'WALFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 366,
          region: 'UK',
          sku: 'WALFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 367,
          region: 'SE',
          sku: 'WALFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 368,
          region: 'EU',
          sku: 'WALFIRST+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 93,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.25',
            value: '+2.25',
            id: 43,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 369,
          region: 'US',
          sku: 'WALFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 370,
          region: 'UK',
          sku: 'WALFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 371,
          region: 'SE',
          sku: 'WALFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 372,
          region: 'EU',
          sku: 'WALFIRST+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 94,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.50',
            value: '+2.50',
            id: 44,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 373,
          region: 'US',
          sku: 'WALFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 374,
          region: 'UK',
          sku: 'WALFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 375,
          region: 'SE',
          sku: 'WALFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 376,
          region: 'EU',
          sku: 'WALFIRST+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 95,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.75',
            value: '+2.75',
            id: 45,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 377,
          region: 'US',
          sku: 'WALFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 378,
          region: 'UK',
          sku: 'WALFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 379,
          region: 'SE',
          sku: 'WALFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 380,
          region: 'EU',
          sku: 'WALFIRST+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 96,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.00',
            value: '+3.00',
            id: 46,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 381,
          region: 'US',
          sku: 'WALFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 382,
          region: 'UK',
          sku: 'WALFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 383,
          region: 'SE',
          sku: 'WALFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 384,
          region: 'EU',
          sku: 'WALFIRST+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 97,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.25',
            value: '+3.25',
            id: 47,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 385,
          region: 'US',
          sku: 'WALFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 386,
          region: 'UK',
          sku: 'WALFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 387,
          region: 'SE',
          sku: 'WALFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 388,
          region: 'EU',
          sku: 'WALFIRST+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 98,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.50',
            value: '+3.50',
            id: 48,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 389,
          region: 'US',
          sku: 'WALFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 390,
          region: 'UK',
          sku: 'WALFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 391,
          region: 'SE',
          sku: 'WALFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 392,
          region: 'EU',
          sku: 'WALFIRST+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 99,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.75',
            value: '+3.75',
            id: 49,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 393,
          region: 'US',
          sku: 'WALFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 394,
          region: 'UK',
          sku: 'WALFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 395,
          region: 'SE',
          sku: 'WALFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 396,
          region: 'EU',
          sku: 'WALFIRST+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 100,
      title: 'Lens Trial',
      handle: 'trial-daily-lenses-positive-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +4.00',
            value: '+4.00',
            id: 50,
          },
        },
        {
          attribute: {
            title: '10 Lenses',
            value: '10',
            id: 51,
          },
        },
      ],
      locales: [
        {
          id: 397,
          region: 'US',
          sku: 'WALFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 398,
          region: 'UK',
          sku: 'WALFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 399,
          region: 'SE',
          sku: 'WALFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 400,
          region: 'EU',
          sku: 'WALFIRST+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
  ],
};
